import React from "react";
import { Link, useParams } from "react-router-dom";

const icons = {
  cleaning: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 7h16M6 7l1 12h10l1-12M9 7V4h6v3"
      />
    </svg>
  ),
  landscaping: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21V10M12 10c0-3 2-5 5-5 0 3-2 5-5 5Zm0 0c0-3-2-5-5-5 0 3 2 5 5 5Z"
      />
    </svg>
  ),
  staff: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M10 11a4 4 0 100-8 4 4 0 000 8ZM20 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
      />
    </svg>
  ),
  mail: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 8l9 6 9-6M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2Z"
      />
    </svg>
  ),
  waste: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 7h16M9 7V4h6v3M6 7l1 12h10l1-12"
      />
    </svg>
  ),
  hvac: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="4" strokeWidth="1.8" />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 2v4M12 18v4M2 12h4M18 12h4"
      />
    </svg>
  ),
  electrical: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 2L3 14h7l-1 8 10-12h-7l1-8Z"
      />
    </svg>
  ),
  laundry: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="4" width="18" height="16" rx="2" strokeWidth="1.8" />
      <circle cx="12" cy="13" r="4" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M8 7h.01M12 7h.01M16 7h.01" />
    </svg>
  ),
  medical: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="7" width="18" height="13" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" strokeLinecap="round" d="M12 11v5M9.5 13.5h5" />
      <path strokeWidth="1.8" d="M9 7V5a3 3 0 016 0v2" />
    </svg>
  ),
  technology: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="4" width="18" height="12" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M8 20h8M10 16v4M14 16v4" />
    </svg>
  ),
  network: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="6" r="2" strokeWidth="1.8" />
      <circle cx="6" cy="18" r="2" strokeWidth="1.8" />
      <circle cx="18" cy="18" r="2" strokeWidth="1.8" />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 8v4M12 12l-4 4M12 12l4 4"
      />
    </svg>
  ),
  support: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18 10c0-3.314-2.686-6-6-6S6 6.686 6 10v4a2 2 0 002 2h1l2 3 2-3h1a2 2 0 002-2v-4Z"
      />
    </svg>
  ),
  cybersecurity: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4Z"
      />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 12l2 2 3-4"
      />
    </svg>
  ),
  cloud: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 18a4 4 0 010-8 5 5 0 019.5-1.5A4 4 0 1118 18H7Z"
      />
    </svg>
  ),
  integration: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="5" width="6" height="6" rx="1" strokeWidth="1.8" />
      <rect x="15" y="5" width="6" height="6" rx="1" strokeWidth="1.8" />
      <rect x="9" y="13" width="6" height="6" rx="1" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M9 8h6M12 11v2" />
    </svg>
  ),
  data: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <ellipse cx="12" cy="5" rx="7" ry="3" strokeWidth="1.8" />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 5v7c0 1.657 3.134 3 7 3s7-1.343 7-3V5M5 12v7c0 1.657 3.134 3 7 3s7-1.343 7-3v-7"
      />
    </svg>
  ),
  modernization: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 12a8 8 0 111.6 4.8M4 16v-4h4"
      />
    </svg>
  ),
  software: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="4" y="4" width="16" height="16" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M8 8h8M8 12h8M8 16h5" />
    </svg>
  ),
  debris: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 17h16M6 17l2-8h8l2 8M9 9l1-3h4l1 3"
      />
    </svg>
  ),
  transport: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="7" width="13" height="9" rx="1" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M16 10h3l2 2v4h-5" />
      <circle cx="7" cy="18" r="2" strokeWidth="1.8" />
      <circle cx="18" cy="18" r="2" strokeWidth="1.8" />
    </svg>
  ),
  temporary: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 19h16M5 19V9l7-5 7 5v10M9 19v-4h6v4"
      />
    </svg>
  ),
  stabilization: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="5" y="8" width="14" height="11" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M9 8V5h6v3" />
    </svg>
  ),
  remediation: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3c3 3 6 6.5 6 10a6 6 0 11-12 0c0-3.5 3-7 6-10Z"
      />
      <path strokeWidth="1.8" d="M10 13c.5 1 1.5 2 3 2" />
    </svg>
  ),
  deployment: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v12M7 10l5-7 5 7M5 21h14"
      />
    </svg>
  ),
  weather: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M8 19l-1 2M12 19l-1 2M16 19l-1 2" />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 17a4 4 0 010-8 5 5 0 019.5-1.5A4 4 0 1118 17H7Z"
      />
    </svg>
  ),
  crisis: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M12 3v6M12 15v6M3 12h6M15 12h6" />
      <circle cx="12" cy="12" r="2.5" strokeWidth="1.8" />
    </svg>
  ),
  fleet: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="9" width="12" height="7" rx="1" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M15 11h3l3 3v2h-6" />
      <circle cx="7" cy="18" r="2" strokeWidth="1.8" />
      <circle cx="17" cy="18" r="2" strokeWidth="1.8" />
    </svg>
  ),
  inventory: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M3 7l9-4 9 4-9 4-9-4Z" />
      <path strokeWidth="1.8" d="M3 7v10l9 4 9-4V7" />
    </svg>
  ),
  distribution: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M12 3v18M3 12h18" />
      <circle cx="12" cy="12" r="8" strokeWidth="1.8" />
    </svg>
  ),
  warehouse: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M3 10l9-6 9 6v10H3V10Z" />
      <path strokeWidth="1.8" d="M9 20v-6h6v6" />
    </svg>
  ),
  snow: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M12 3v18M5 7l14 10M19 7L5 17M4 12h16" />
    </svg>
  ),
  textiles: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 7c3 0 4-2 7-2s4 2 7 2v10c-3 0-4 2-7 2s-4-2-7-2V7Z"
      />
    </svg>
  ),
};

const serviceCategories = {
  facilities: {
    title: "Facility Management & Support Services",
    image: "/images/services/janitorial_service.jpg",
    heroDescription:
      "Reliable facility operations, maintenance, and support services for federal and commercial environments.",
    overview:
      "Providence Federal Group delivers integrated facility support solutions that help federal, healthcare, and institutional environments remain safe, compliant, and fully operational.",
    includedServices: [
      {
        title: "Janitorial & Custodial Services",
        naicsCode: "561720",
        description:
          "Routine cleaning, sanitation, and custodial support for federal and commercial facilities.",
        icon: icons.cleaning,
      },
      {
        title: "Grounds Maintenance & Landscaping",
        naicsCode: "561730",
        description:
          "Exterior upkeep, landscaping, and grounds maintenance for safe and professional environments.",
        icon: icons.landscaping,
      },
      {
        title: "Facilities Staffing Support",
        naicsCode: "561210",
        description:
          "Operational and administrative staffing support for facility-based environments.",
        icon: icons.staff,
      },
      {
        title: "Mailroom & Internal Distribution",
        naicsCode: "561210",
        description:
          "Mail handling, package distribution, and internal support services for organized site operations.",
        icon: icons.mail,
      },
      {
        title: "Waste Management & Removal",
        naicsCode: "562111",
        description:
          "Waste collection, removal, and related support for clean and compliant facilities.",
        icon: icons.waste,
      },
      {
        title: "HVAC Maintenance Support",
        naicsCode: "238220",
        description:
          "Heating, ventilation, and air-conditioning maintenance support for operational continuity.",
        icon: icons.hvac,
      },
      {
        title: "Electrical Maintenance Support",
        naicsCode: "238210",
        description:
          "Electrical support services to help maintain safe and functional facility systems.",
        icon: icons.electrical,
      },
      {
        title: "Laundry & Linen Services",
        naicsCode: "812331",
        description:
          "Linen processing and laundry support for healthcare and institutional environments.",
        icon: icons.laundry,
      },
      {
        title: "Medical Supplies Support",
        naicsCode: "339113",
        description:
          "Handling and operational support related to medical supply environments and workflows.",
        icon: icons.medical,
      },
    ],
    naicsCodes: [
      "561210 – Stub NAICS Code",
      "561720 – Stub NAICS Code",
      "561730 – Stub NAICS Code",
      "562111 – Stub NAICS Code",
    ],
  },

  technology: {
    title: "IT & Technology Services",
    image: "/images/services/IT_services.jpg",
    heroDescription:
      "Secure, scalable technology support for federal and mission-critical environments.",
    overview:
      "Providence Federal Group provides technology support services that help agencies improve reliability, security, modernization, and operational efficiency.",
    includedServices: [
      {
        title: "IT Infrastructure Support",
        naicsCode: "541519",
        description:
          "Support for hardware, systems, and core technical infrastructure across operational environments.",
        icon: icons.technology,
      },
      {
        title: "Network Administration",
        naicsCode: "541512",
        description:
          "Network configuration, monitoring, and support to maintain secure and reliable connectivity.",
        icon: icons.network,
      },
      {
        title: "Help Desk & End-User Support",
        naicsCode: "541519",
        description:
          "Responsive technical support for users, systems, and day-to-day operational issues.",
        icon: icons.support,
      },
      {
        title: "Cybersecurity Support Services",
        naicsCode: "541519",
        description:
          "Security-focused support to strengthen resilience, monitoring, and risk management.",
        icon: icons.cybersecurity,
      },
      {
        title: "Cloud Migration & Cloud Support",
        naicsCode: "518210",
        description:
          "Cloud implementation and support services to improve flexibility and system availability.",
        icon: icons.cloud,
      },
      {
        title: "Systems Integration",
        naicsCode: "541512",
        description:
          "Integration support to connect platforms, workflows, and operational systems efficiently.",
        icon: icons.integration,
      },
      {
        title: "Data Management & Reporting",
        naicsCode: "518210",
        description:
          "Data support services for organization, access, reporting, and operational visibility.",
        icon: icons.data,
      },
      {
        title: "Technology Modernization Support",
        naicsCode: "541512",
        description:
          "Support for modernization efforts aimed at improving security, performance, and scalability.",
        icon: icons.modernization,
      },
      {
        title: "Software Support & Implementation",
        naicsCode: "541511",
        description:
          "Implementation and support for software solutions aligned with operational requirements.",
        icon: icons.software,
      },
    ],
    naicsCodes: [
      "541511 – Stub NAICS Code",
      "541512 – Stub NAICS Code",
      "541513 – Stub NAICS Code",
      "541519 – Stub NAICS Code",
    ],
  },

  emergency: {
    title: "Emergency Response & Disaster Recovery",
    image: "/images/services/emergency_response.jpg",
    heroDescription:
      "Rapid-response emergency support and disaster recovery services for federal facilities and communities.",
    overview:
      "Providence Federal Group supports emergency response and recovery operations with disciplined mobilization, safety-first execution, and mission continuity support.",
    includedServices: [
      {
        title: "Debris Removal",
        naicsCode: "562910",
        description:
          "Site clearing and debris removal support following weather events, emergencies, and disruptions.",
        icon: icons.debris,
      },
      {
        title: "Emergency Logistics Coordination",
        naicsCode: "561990",
        description:
          "Time-sensitive logistics support to help coordinate personnel, equipment, and supplies.",
        icon: icons.transport,
      },
      {
        title: "Temporary Operational Support",
        naicsCode: "624230",
        description:
          "Short-term staffing and operational assistance to help maintain continuity during response efforts.",
        icon: icons.temporary,
      },
      {
        title: "Facility Stabilization Support",
        naicsCode: "562910",
        description:
          "Immediate support services to help secure and stabilize facilities after disruptive events.",
        icon: icons.stabilization,
      },
      {
        title: "Disaster Cleanup Support",
        naicsCode: "562910",
        description:
          "Post-event cleanup services to restore safety, usability, and operational readiness.",
        icon: icons.cleaning,
      },
      {
        title: "Environmental Remediation Coordination",
        naicsCode: "562910",
        description:
          "Support for managing remediation-related activities in regulated or sensitive environments.",
        icon: icons.remediation,
      },
      {
        title: "Rapid Deployment Staffing",
        naicsCode: "561990",
        description:
          "Quick mobilization of support personnel for emergency and recovery operations.",
        icon: icons.deployment,
      },
      {
        title: "Storm & Flood Response Support",
        naicsCode: "624230",
        description:
          "Response assistance for storm-related and flood-related events affecting facilities and operations.",
        icon: icons.weather,
      },
      {
        title: "Crisis Operations Support",
        naicsCode: "561990",
        description:
          "Structured operational support to help agencies respond effectively during high-pressure events.",
        icon: icons.crisis,
      },
    ],
    naicsCodes: [
      "562910 – Stub NAICS Code",
      "624230 – Stub NAICS Code",
      "561990 – Stub NAICS Code",
    ],
  },

  logistics: {
    title: "Logistics & Groundskeeping Services",
    image: "/images/services/distribution_service.jpg",
    heroDescription:
      "Reliable logistics, transportation, and groundskeeping services supporting federal operations nationwide.",
    overview:
      "Providence Federal Group provides logistics and groundskeeping support that helps federal properties remain efficient, accessible, and operationally ready.",
    includedServices: [
      {
        title: "Transportation Support",
        naicsCode: "484110",
        description:
          "Transportation coordination and movement support for equipment, materials, and supplies.",
        icon: icons.transport,
      },
      {
        title: "Fleet Coordination Support",
        naicsCode: "488510",
        description:
          "Operational support for vehicle scheduling, movement, and fleet-related logistics.",
        icon: icons.fleet,
      },
      {
        title: "Inventory & Asset Support",
        naicsCode: "493110",
        description:
          "Inventory handling and asset tracking support to improve operational control and readiness.",
        icon: icons.inventory,
      },
      {
        title: "Supply Distribution",
        naicsCode: "493110",
        description:
          "Distribution support for materials, supplies, and internal operational needs.",
        icon: icons.distribution,
      },
      {
        title: "Mail & Internal Courier Support",
        naicsCode: "561210",
        description:
          "Mail routing, courier handling, and internal distribution services for busy environments.",
        icon: icons.mail,
      },
      {
        title: "Warehousing Support",
        naicsCode: "493110",
        description:
          "Storage, handling, and warehouse-related support for organized supply operations.",
        icon: icons.warehouse,
      },
      {
        title: "Groundskeeping & Landscaping",
        naicsCode: "561730",
        description:
          "Landscape upkeep and exterior maintenance to maintain safe and professional grounds.",
        icon: icons.landscaping,
      },
      {
        title: "Snow & Ice Removal",
        naicsCode: "561730",
        description:
          "Seasonal clearing services to support access, safety, and continuity of operations.",
        icon: icons.snow,
      },
      {
        title: "Junk Removal & Site Clearing",
        naicsCode: "562111",
        description:
          "Removal and disposal support for site cleanup, maintenance, and operational readiness.",
        icon: icons.waste,
      },
    ],
    naicsCodes: [
      "484110 – Stub NAICS Code",
      "488510 – Stub NAICS Code",
      "493110 – Stub NAICS Code",
      "561730 – Stub NAICS Code",
    ],
  },

  laundry: {
    title: "Laundry & Linen Services",
    image: "/images/services/laundry_service.jpg",
    heroDescription:
      "High-compliance laundry and linen services supporting healthcare and institutional environments.",
    overview:
      "Providence Federal Group provides dependable linen and textile support services designed for hygiene, consistency, and operational reliability.",
    includedServices: [
      {
        title: "Medical Laundry Services",
        naicsCode: "812331",
        description:
          "Specialized laundry support for healthcare and medically sensitive environments.",
        icon: icons.medical,
      },
      {
        title: "Linen Processing",
        naicsCode: "812331",
        description:
          "Processing and handling of linens to support clean, consistent, and reliable operations.",
        icon: icons.laundry,
      },
      {
        title: "Uniform Laundering",
        naicsCode: "812320",
        description:
          "Cleaning and maintenance support for uniforms used in operational and institutional settings.",
        icon: icons.textiles,
      },
      {
        title: "Linen Distribution Support",
        naicsCode: "812331",
        description:
          "Support for organizing, distributing, and maintaining linen supply workflows.",
        icon: icons.distribution,
      },
      {
        title: "Infection-Control Compliant Washing",
        naicsCode: "812320",
        description:
          "Laundry processes aligned with hygiene and infection-control requirements.",
        icon: icons.cleaning,
      },
      {
        title: "Textile Sanitation Support",
        naicsCode: "812320",
        description:
          "Sanitation-focused textile handling to support health, safety, and cleanliness standards.",
        icon: icons.textiles,
      },
      {
        title: "Pickup & Delivery Coordination",
        naicsCode: "484110",
        description:
          "Coordinated transport support for collection and delivery of linens and related materials.",
        icon: icons.transport,
      },
    ],
    naicsCodes: [
      "812331 – Stub NAICS Code",
      "812320 – Stub NAICS Code",
    ],
  },
};

const ServicesDetail = () => {
  const { serviceId } = useParams();
  const service = serviceCategories[serviceId];

  if (!service) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="text-center max-w-xl">
          <h1 className="text-3xl md:text-4xl font-bold text-[#2C3E50] mb-4">
            Service Category Not Found
          </h1>
          <p className="text-gray-600 mb-8">
            The requested service category could not be found.
          </p>
          <Link
            to="/services"
            className="inline-flex items-center px-6 py-3 bg-[#C5A047] text-white rounded-full font-semibold hover:bg-[#D4AF37] transition-colors"
          >
            Back to Services
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      <section className="relative min-h-[65vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="mb-4">
            <span className="inline-block px-4 py-1 bg-[#C5A047]/20 text-[#F5D27A] text-sm font-semibold rounded-full">
              CORE CAPABILITY
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {service.title}
          </h1>

          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            {service.heroDescription}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10">
            <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Overview
            </h2>

            <p className="text-gray-700 text-lg leading-relaxed">
              {service.overview}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 bg-[#C5A047]/10 text-[#C5A047] text-sm font-semibold rounded-full mb-3">
              INCLUDED SERVICES
            </span>

            <h2 className="text-3xl md:text-4xl font-bold text-[#2C3E50] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Included Services
            </h2>

            <p className="text-gray-600 max-w-3xl mx-auto">
              A structured overview of the services provided within this category.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {service.includedServices.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300"
              >
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div>
                    <h3 className="text-lg font-bold text-[#2C3E50] leading-snug">
                      {item.title}
                    </h3>

                    <div className="mt-2 inline-block px-3 py-1 rounded-full bg-[#C5A047]/10 text-[#C5A047] text-xs font-semibold tracking-wide">
                      NAICS {item.naicsCode}
                    </div>
                  </div>

                  {item.icon && <div className="flex-shrink-0">{item.icon}</div>}
                </div>

                <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-[#2C3E50] rounded-2xl p-8 md:p-12 shadow-lg">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Need Support in This Area?
            </h2>

            <p className="text-white/85 text-lg mb-8 max-w-2xl mx-auto">
              Contact Providence Federal Group to discuss requirements, service
              scope, and operational support needs.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-3 bg-[#C5A047] text-white font-semibold rounded-full hover:bg-[#D4AF37] transition-colors min-w-[220px]"
              >
                Request a Consultation
              </Link>

              <Link
                to="/services"
                className="inline-flex items-center justify-center px-8 py-3 border border-white text-white font-semibold rounded-full hover:bg-white hover:text-[#2C3E50] transition-colors min-w-[220px]"
              >
                Back to Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesDetail;